import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'truncateFileUrl', standalone: true })
export class TruncateFileUrlPipe implements PipeTransform {
  transform(value: string) {
    return value.split('/').at(-1)?.split('?').at(0);
  }
}
